/**
 * @file 見取り図の「次に何をするか」の 1 区分 (取り組み中 / 教材がまだ決まっていない単元 / 教材を使い終えた単元)。
 *
 * @what: 見出しと件数、単元名の一覧。空なら何をすれば並ぶかの文だけを出す。
 * @why: 教材を数冊使い終えたあとに「次は何か」で迷わないための一覧 (代表 2026-08-23)。
 * @failure: 描画のみ。
 */

import "./study.css";

export function RoadmapNextList({
  title,
  units,
  empty,
}: {
  title: string;
  units: readonly { id: string; label: string }[];
  empty: string;
}) {
  return (
    <div className="study-roadmap-now-group">
      <div className="study-roadmap-now-group-title">
        {title}
        <span className="study-roadmap-now-count">{units.length}</span>
      </div>
      {units.length > 0 ? (
        <ul className="study-roadmap-now-list">
          {units.map((u) => (
            <li key={u.id}>{u.label}</li>
          ))}
        </ul>
      ) : (
        <p className="study-map-empty">{empty}</p>
      )}
    </div>
  );
}
